import { FxIcon } from '@/components/fx'

import { UNDO_LABEL, savedMessage, undoKind, type SavedWrite } from './bulkModel'

/**
 * The confirmation of the last write, with whatever can honestly be offered
 * about it — see `undoKind`. A correction can be taken back by correcting
 * back; an acceptance cannot be un-reviewed, so the offer is to open the row
 * again rather than a button that would lie.
 *
 * `role="status"` rather than `alert`: it follows an action the person just
 * took, and a screen reader interrupting them mid-keystroke on every Enter
 * would make the fast path unusable.
 */
export function SavedToast({
  write,
  busy,
  onAction,
}: {
  write: SavedWrite
  busy?: boolean
  onAction: (kind: 'repost' | 'reopen') => void
}) {
  const kind = undoKind(write)
  return (
    <div
      role="status"
      className="fixed bottom-8 left-1/2 z-40 flex -translate-x-1/2 items-center gap-4 rounded-md bg-text px-5 py-2 text-on-primary shadow-overlay"
    >
      <FxIcon name="check_circle" size={20} />
      <span>{savedMessage(write)}</span>
      <button
        type="button"
        disabled={busy}
        onClick={() => onAction(kind)}
        className="h-tab rounded-md px-2 font-semibold text-primary-tonal hover:underline disabled:opacity-50"
      >
        {UNDO_LABEL[kind]}
      </button>
    </div>
  )
}
